import { reducer as toastrReducer } from 'react-redux-toastr'
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { AUTH_LOGOUT, AUTH_SELECT_TENANT } from "./actions/actionTypes";

import printReducer from './reducers/print';
import drawerReducer from './reducers/drawer';
import authReducer from './reducers/auth';
import usersReducer from './reducers/users';
import actionsReducer from './reducers/actions';
import areasReducer from './reducers/areas';
import tenantsReducer from './reducers/tenants';
import sitesReducer from './reducers/sites';
import rolesReducer from './reducers/roles';
import companiesReducer from './reducers/companies';
import PlacesReducer from './reducers/places';
import ServiceTypesReducer from './reducers/serviceTypes';
import frequencyReducer from './reducers/frequency';
import statusVerificationItemsReducer from './reducers/statusVerificationItems';
import groupsReducer from './reducers/groups';
import equipmentModelsReducer from './reducers/equipmentModels'
import equipmentsReducer from './reducers/equipments'
import servicesReducer from './reducers/services'
import equipmentServicesReducer from './reducers/equipmentServices'
import questionsReducer from './reducers/questions'
import serviceFormReducer from './reducers/serviceForm'
import tokensReducer from './reducers/tokens';
import calendarsReducer from './reducers/calendars';
import quicksightReducer from './reducers/quicksight';
import supportFilesReducer from './reducers/supportFiles'
import backupsAppReducer from './reducers/backupsApp'
import logsReducer from './reducers/logs'
import logsSuperadminReducer from './reducers/logsSuperadmin'
import maintenancesReducer from './reducers/maintenances'
import reportsReducer from './reducers/reports';
import equipmentsPublicReducer from './reducers/equipmentsPublic'
import emailLogsReducer from './reducers/emailLogs';
import expiredServicesReducer from './reducers/expiredServices'
import createServiceReducer from './reducers/createService';
import editServiceReducer from './reducers/editService';
import scheduledServicesReducer from './reducers/scheduledServices';
import dataExports from './reducers/dataExports';
import hyperflowReducer from './reducers/hyperflow';
import serviceDraftsReducer from './reducers/serviceDrafts';

const appReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  actions: actionsReducer,
  areas: areasReducer,
  sites: sitesReducer,
  roles: rolesReducer,
  companies: companiesReducer,
  toastr: toastrReducer,
  places: PlacesReducer,
  serviceTypes: ServiceTypesReducer,
  frequency: frequencyReducer,
  statusVerificationItems: statusVerificationItemsReducer,
  groups: groupsReducer,
  equipmentModels: equipmentModelsReducer,
  equipments: equipmentsReducer,
  services: servicesReducer,
  equipmentServices: equipmentServicesReducer,
  questions: questionsReducer,
  tenants: tenantsReducer,
  print: printReducer,
  serviceForm: serviceFormReducer,
  tokens: tokensReducer,
  calendars: calendarsReducer,
  quicksight: quicksightReducer,
	drawer: drawerReducer,
  supportFiles: supportFilesReducer,
  backupsApp: backupsAppReducer,
  logs: logsReducer,
  logsSuperadmin: logsSuperadminReducer,
  emailLogs: emailLogsReducer,
  maintenances: maintenancesReducer,
  reports: reportsReducer,
  equipmentsPublic: equipmentsPublicReducer,
  expiredServices: expiredServicesReducer,
  createService: createServiceReducer,
  editService: editServiceReducer,
  scheduledServices: scheduledServicesReducer,
  dataExports: dataExports,
  hyperflow: hyperflowReducer,
  serviceDrafts: serviceDraftsReducer,
})

// const composeEnhancers = process.env.NODE_ENV === 'development' ? (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) : null || compose;
const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

const rootReducer = (state, action) => {   
	if (action.type === AUTH_LOGOUT || action.type === AUTH_SELECT_TENANT) {
		state = undefined;
	}
	
	return appReducer(state, action);
};

const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk)
));

export default store;
